export default __webpack_public_path__ + "static/media/fileVersion.483db573.png";